const ActionStatus = {
  UNSTARTED: {
    id: 'unstarted',
    value: -1
  },
  STARTED: {
    id: 'started',
    value: 1
  },
  SINGULAR: {
    id: 'singular',
    value: 2
  },
  ENDED: {
    id: 'ended',
    value: 3
  }
};

export { ActionStatus };
